import { render, staticRenderFns } from "./EditResourceDialog.vue?vue&type=template&id=79717e8c&scoped=true&"
import script from "./edit_resource_dialog.js?vue&type=script&lang=js&"
export * from "./edit_resource_dialog.js?vue&type=script&lang=js&"
import style0 from "./EditResourceDialog.vue?vue&type=style&index=0&id=79717e8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79717e8c",
  null
  
)

export default component.exports